import { render, staticRenderFns } from "./TravelInfo.vue?vue&type=template&id=8839c276&scoped=true"
import script from "./TravelInfo.vue?vue&type=script&lang=js"
export * from "./TravelInfo.vue?vue&type=script&lang=js"
import style0 from "./TravelInfo.vue?vue&type=style&index=0&id=8839c276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8839c276",
  null
  
)

export default component.exports